import React, { useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Row,
  Col,
  Checkbox,
  Select,
  Table,
} from "antd";
import { useSelector } from "react-redux";

const { Option } = Select;

const CreateFolderModal = ({
  isVisible,
  onCancel,
  onSubmit,
  loading,
  form,
  editingFolder,
  folders,
  parentFolderForModal,
  apiRoles = [],
  apiCountries = [],
  selectedCountry = "United States",
}) => {
  const userInfo = useSelector((state) => state.user);

  useEffect(() => {
    if (isVisible) {
      if (editingFolder) {
        // Populate form with existing folder data
        form.setFieldsValue({
          folderName: editingFolder.name,
          country: editingFolder.country || selectedCountry,
          description: editingFolder.description,
          permissions: editingFolder.permissions,
          parentFolder: editingFolder.parentId,
        });
      } else {
        // Set default values for new folder
        form.setFieldsValue({
          country: selectedCountry,
          parentFolder: parentFolderForModal?.id || null,
        });
      }
    }
  }, [isVisible, userInfo, form, editingFolder, parentFolderForModal]);

  return (
    <Modal
      title={
        <span
          style={{
            fontSize: "1.4rem",
            fontFamily: "Poppins",
            fontWeight: "600",
          }}
        >
          {editingFolder ? "Edit Folder" : "Create New Folder"}
        </span>
      }
      open={isVisible}
      onCancel={onCancel}
      footer={null}
      width={700}
      style={{ top: 20 }}
      bodyStyle={{
        maxHeight: "calc(80vh - 50px)",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
        className="antd-test-modal"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="folderName"
              label={<p className="docustore-form-lables">Folder Name</p>}
              rules={[{ required: true, message: "Please enter folder name" }]}
            >
              <Input
                placeholder="Enter folder name"
                className="my-form-input-antd-test"
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: "6px",
                  boxShadow: "none",
                  fontSize: "1.2rem",
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="country"
              label={<p className="docustore-form-lables">Country</p>}
              rules={[{ required: true, message: "Please select country" }]}
            >
              <Select
                showSearch
                placeholder="Select country"
                className="my-form-input-antd-test"
                style={{
                  borderRadius: "6px",
                  border: "1px solid #d9d9d9",
                  boxShadow: "none",
                  fontSize: "1rem",
                }}
              >
                {apiCountries.map((country) => (
                  <Option key={country} value={country}>
                    {country}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {/* Only show parent folder selection when creating subfolder from main folder plus button */}
        {/* {parentFolderForModal && (
          <Form.Item
            name="parentFolder"
            label={<p className="docustore-form-lables">Parent Folder</p>}
          >
            <Select
              placeholder={`Creating subfolder in: ${parentFolderForModal.name}`}
              className="my-form-input-antd-test"
              style={{ 
                borderRadius: "6px",
                border: "1px solid #d9d9d9",
                boxShadow: "none"
              }}
              disabled
            >
              <Option value={parentFolderForModal.id}>{parentFolderForModal.name}</Option>
            </Select>
          </Form.Item>
        )} */}

        {/* Show parent folder selection for editing or when no specific parent is set */}
        {/* {!parentFolderForModal && editingFolder && (
          <Form.Item
            name="parentFolder"
            label={
              <p className="docustore-form-lables">Parent Folder (Optional)</p>
            }
          >
            <Select
              showSearch
              placeholder="Select parent folder (leave empty for root level)"
              className="my-form-input-antd-test"
              style={{
                borderRadius: "6px",
                border: "1px solid #d9d9d9",
                boxShadow: "none",
              }}
              allowClear
            >
              {Array.isArray(folders) ? folders
                .filter((f) => !f.parentId && f.id !== editingFolder?.id)
                .map((folder) => (
                  <Option key={folder.id} value={folder.id}>
                    {folder.name}
                  </Option>
                )) : []}
            </Select>
          </Form.Item>
        )} */}

        <Form.Item
          name="description"
          label={<p className="docustore-form-lables">Description</p>}
        >
          <Input.TextArea
            placeholder="Enter folder description"
            rows={3}
            className="my-form-input-antd-test"
            style={{
              border: "1px solid #d9d9d9",
              borderRadius: "6px",
              boxShadow: "none",
            }}
          />
        </Form.Item>

        <Form.Item
          label={<p className="docustore-form-lables">Role Permissions</p>}
        >
          <div
            style={{
              maxHeight: "300px",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Table
              size="small"
              dataSource={apiRoles.map((role) => ({
                key: role.id,
                role: role.name,
                keyName: role.key_name,
              }))}
              pagination={false}
              bordered
              className="table-container"
              scroll={{ y: 250, x: false }}
              columns={[
                {
                  title: "Roles",
                  dataIndex: "role",
                  key: "role",
                  render: (role) => (
                    <span style={{ fontSize: "1.3rem", fontFamily: "Poppins" }}>
                      {role}
                    </span>
                  ),
                },
                {
                  title: "Read",
                  key: "read",
                  align: "center",
                  render: (_, record) => (
                    <Form.Item
                      name={["permissions", record.keyName, "read"]}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox />
                    </Form.Item>
                  ),
                },
                {
                  title: "Add/Edit",
                  key: "edit",
                  align: "center",
                  render: (_, record) => (
                    <Form.Item
                      name={["permissions", record.keyName, "edit"]}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox />
                    </Form.Item>
                  ),
                },
                {
                  title: "Delete",
                  key: "delete",
                  align: "center",
                  render: (_, record) => (
                    <Form.Item
                      name={["permissions", record.keyName, "delete"]}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox />
                    </Form.Item>
                  ),
                },
              ]}
            />
          </div>
        </Form.Item>

        <Form.Item
          style={{ marginBottom: 0, textAlign: "right", marginTop: "2rem" }}
        >
          <Button
            onClick={onCancel}
            style={{
              marginRight: "16px",
              fontFamily: "Poppins",
              fontSize: "1.3rem",
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            className="update-btn-info"
            style={{ fontFamily: "Poppins", fontSize: "1.3rem" }}
          >
            {editingFolder ? "Update Folder" : "Create Folder"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateFolderModal;
